import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Namespaces } from "../components/LanguageSelector";
import "./Achievement.css";

export default function Achievement({ data, image }) {
  const { t } = useTranslation();

  const {
    name,
    nameTranslationCode,
  } = data;

  const nameTranslation = t(`${Namespaces.awards}.${nameTranslationCode}`);

  const trickName = nameTranslationCode && nameTranslation
    ? nameTranslation
    : name;

  return (
    <div className="achievement mb-3">
      <Link to={`/awards/${data.id}`}>
        <img
          className="achievement__img rounded-circle shadow"
          src={image}
          alt={t(`${Namespaces.achievement}.achievementImageAltText`)}
        />
        <div className="text-size-secondary mt-2 text-center">{trickName}</div>
      </Link>
    </div>
  );
}
